import React from "react";
import BenefitsAndFeaturesSection from "../components/Common/ui/BenefitsAndFeaturesSection";
import { Box, Container, Grid, Typography } from "@mui/material";
import benifitsIcon from "./../assets/images/Benifits/benifitsIcon.svg";
import benifitsIcon2 from "./../assets/images/Benifits/benifitsIcon2.svg";
import benifitsIcon3 from "./../assets/images/Benifits/benifitsIcon3.svg";
import benifitsIcon4 from "./../assets/images/Benifits/benifitsIcon4.svg";
import HiringExcellence from "../components/Common/ui/HiringExcellence";
const BenefitsPage: React.FC = () => {
  const data = [
    {
      icon: <img src={benifitsIcon} />,
      feature: [
        {
          title: "1. Identifies and Sources Candidates",
          desc: "Access a rich talent pool instantly",
        },
        {
          title: "2. Skills Assessment",
          desc: "Evaluate candidates accurately in minutes",
        },
        {
          title: "3. Candidate Ranking",
          desc: "Get detailed reports to identify top talent",
        },
      ],
      benefits: [
        "Evaluates and measures skills in minutes",
        "Ranks best candidates providing detailed reports",
      ],
    },
    {
      icon: <img src={benifitsIcon2} />,
      feature: [
        {
          title: "4. AI Conversations",
          desc: "Interact with candidates via email, SMS, and voice.",
        },
      ],
      benefits: [
        "Converses with candidates using email, SMS, and voice",
        "Reports, interest, summary, formal job application",
      ],
    },
    {
      icon: <img src={benifitsIcon3} />,
      feature: [
        {
          title: "5. Interview Scheduling",
          desc: "Seamlessly align candidate and recruiter availability.",
        },
      ],
      benefits: [
        "Schedules formal interviews",
        "Provides suggested format and interview questions",
      ],
    },
    {
      icon: <img src={benifitsIcon4} />,
      feature: [
        {
          title: "6. Onboarding Assistance",
          desc: "Ensure smooth onboarding for every hire.",
        },
      ],
      benefits: [
        "Onboards new employees and contractors",
        "Provides formal offers",
      ],
    },
  ];

  return (
    <>
    <Container maxWidth="lg">
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Box sx={{ marginTop: "50px", textAlign: "center" }}>
            {/* Header Section */}
            <Typography fontWeight={600} fontSize={40}>
              Advanced Tools for Smarter
            </Typography>
            <Typography  fontWeight={600} fontSize={40} mt={-2}>
              and Efficient Hiring
            </Typography>
            <Typography  fontWeight={400} fontSize={20} color="#56595C" mt={-2}>
              Eximius AI streamlines your entire recruitment process.
            </Typography>

            {/* Benefits and Features Section */}
            <Typography variant="h5" fontWeight={600} fontSize={32} mt={4} mb={0}>
              Benefits and Features
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} mt={0}>
          {data.map((item, index) => (
            <BenefitsAndFeaturesSection
              key={index}
              icon={item.icon}
              feature={item.feature}
              benefits={item.benefits}
            />
          ))}
        </Grid>
      </Grid>
      
    </Container>
    <HiringExcellence />
    </>
    
  );
};

export default BenefitsPage;
